var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-t-xs-20 p-b-xs-20" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-12" },
          [
            _c(
              "div",
              { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
              [
                _c(
                  "div",
                  { staticClass: "ak-panel__header ak-panel__header--small" },
                  [
                    _c("div", { staticClass: "ak-panel__title" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("Validatie resultaat")) +
                          "\n                        "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "table",
                  { staticClass: "ak-table ak-table--compact ak-panel__table" },
                  [
                    _c("thead", [
                      _c("tr", { staticClass: "ak-table-row" }, [
                        _c("th", { staticClass: "ak-table-head" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.$t("Barcode")) +
                              "\n                                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "ak-table-head" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.$t("Pincode")) +
                              "\n                                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "ak-table-head" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.$t("Status")) +
                              "\n                                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "ak-table-head" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.$t("Foutmelding")) +
                              "\n                                "
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      { staticClass: "ak-table-body" },
                      _vm._l(_vm.output.items, function (item) {
                        return _c(
                          "tr",
                          {
                            key: item.barcode,
                            staticClass: "ak-table-row",
                            class: { "tr-danger": !item.isValid },
                          },
                          [
                            _c("td", { staticClass: "ak-table-column" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(item.barcode) +
                                  "\n                                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "ak-table-column" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(item.pincode) +
                                  "\n                                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "ak-table-column" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    item.isValid ? _vm.$t("Ok") : _vm.$t("Fout")
                                  ) +
                                  "\n                                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", {
                              staticClass: "ak-table-column",
                              domProps: {
                                innerHTML: _vm._s(item.errorForDisplay),
                              },
                            }),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            !_vm.output.hasInvalid
              ? _c("ak-button", { on: { click: _vm.submit } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("Importeren")) +
                      "\n                "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "ak-button",
              {
                attrs: {
                  enableConfirm: true,
                  confirmTitle: _vm.$t("Ben je zeker?"),
                  confirmText: _vm.$t("Ben je zeker dat je wil annuleren?"),
                },
                on: { click: _vm.cancel },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("Annuleren")) +
                    "\n                "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }